import { useEffect, useRef, useState } from 'react'
import { breakpointQueries, useMediaQuery } from '@systemeio/components'

export const useIsMobileWhileOpen = (open: boolean): boolean => {
  const liveIsMobile = useMediaQuery(breakpointQueries.isMobile, { initializeWithValue: false })
  const [isMobile, setIsMobile] = useState(liveIsMobile)
  const previousOpenRef = useRef(open)
  const capturedRef = useRef(false)

  useEffect(() => {
    if (!open) {
      capturedRef.current = false
      setIsMobile(liveIsMobile)
    } else if (!previousOpenRef.current) {
      capturedRef.current = true
      setIsMobile(liveIsMobile)
    } else if (!capturedRef.current) {
      capturedRef.current = true
      setIsMobile(globalThis.matchMedia(breakpointQueries.isMobile).matches)
    }
    previousOpenRef.current = open
  }, [open, liveIsMobile])

  return isMobile
}
